export default "__VITE_ASSET__cb7c7d9e__"